import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import ListItem from "./ListItem";

class Lista extends React.Component {
  state = {};

  render() {
    const { classes, beneficios, isLogged, programLogo } = this.props;

    return (
      <div className={classes.container}>
        <Grid container spacing={16}>
          {beneficios.map(beneficio => (
            <ListItem
              isLogged={isLogged}
              key={`lista-beneficio-${beneficio.idBeneficio}`}
              beneficio={beneficio}
              classes={classes}
              programLogo={programLogo}
            />
          ))}
        </Grid>
      </div>
    );
  }
}

Lista.propTypes = {
  classes: PropTypes.object.isRequired
};

export default Lista;
